import React from 'react';

export default function AddPlacesScreen() {
  return (
    <div>
      <h1>Hello World 1</h1>
    </div>
  );
}
